import { ReactNode, useMemo, useReducer } from "react";
import GfeContext from "../gfe_context";
import { gfeReducer, INITIAL_GFE_STATE } from "../reducer/gfe_reducer";

export default function GoodFaithEffortProvider(props: { children: ReactNode }) {
  const [state, dispatch] = useReducer(gfeReducer, INITIAL_GFE_STATE);
  const value = useMemo(() => ({ state, dispatch }), [state]);

  return <GfeContext.Provider value={value}>{props.children}</GfeContext.Provider>;
}
